<script>
 


   
    export default {
        

 
 
        created: function () {
            localStorage.setItem('language', 'it');
            localStorage.removeItem('access_token');
            window.location.href='/login';
        
        },
      
    }
</script>
